import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as $ from 'jquery';
require('fullcalendar');
require('fullcalendar/dist/fullcalendar.css');
import { Moment } from "moment";
import { namespace } from 'vuex-class';
import { AGENDA_MODULE_NAMESPACE, AGENDA_GET_APPOINTMENTS, AGENDA_GET_APPOINTMENTS_TICKET, AGENDA_SET_APPOINTMENT_BY_FIELD, AGENDA_MODIFY, AGENDA_GET_APPOINTMENT_BY_ID, AGENDA_DELETE, AGENDA_ASSIGN_APPOINTMENT, AGENDA_RECORD } from '../../../../store/agenda/agenda-types.store';
import { IAppointmentParameter, AppointmentParameterDto, IAppointmentListingViewModel, IAppointment, AppointmentListingViewModel, IAppointmentListing, IAppointmentQuickUpdate } from '../../../../models/appointment';
import moment = require('moment');
import { AppointmentTypes, AppointmentState } from '../../../../common/enums';
import * as _ from "lodash";
import Axios from 'axios';

const calendar = '#ticket-calendar'

const AgendaStore = namespace(AGENDA_MODULE_NAMESPACE)


@Component({
  components: {
    'agenda-modal-vertical': async () => import("@/containers/agenda/components/agenda-modal-vertical/AgendaModalVertical.vue")
  }
})
class TicketCalendar extends Vue {

  previousAppointment: { [key: string]: any } | null;
  originalAppointments: IAppointment[];

  dtIsRender: boolean
  dtIsLoading: boolean
  dtCalendarSearchParam: IAppointmentParameter;
  _agentView: any
  dtEvents: IAppointmentListingViewModel[]
  dtEventId: string
  dtValidateIsLoading: boolean
  dtAgendaDialogVisible: boolean

  get lblSetting() {
    return {
      ...require('@/locales/agenda').default,
      ...require('@/locales/button').default
    }
  }
  // @Prop({ required: true, type: [String] })
  // endDate: string

  @Prop({ required: true, type: [Object] })
  blockInfo: any

  @Prop({ required: true, type: [Array] })
  ics: any[]

  @Prop({ default: false, type: [Boolean] })
  udpateAppointmentField: boolean

  /**
   *
   */
  constructor() {
    super();
    this.dtValidateIsLoading = false;
    this.dtAgendaDialogVisible = false;
    this.previousAppointment = null;
    this.originalAppointments = [];
    this.dtEventId = "-1";
    this.dtIsRender = false;
    this.dtCalendarSearchParam = new AppointmentParameterDto({
      firstday: moment().format("YYYY-MM-DD")
    })
    this.dtIsLoading = false
    this.dtEvents = [];
  }

  @AgendaStore.Getter appointment: IAppointmentListing

  @AgendaStore.Action(AGENDA_GET_APPOINTMENTS_TICKET)
  storeGetAppointments: (IAppointmentParameter) => Promise<IAppointmentListingViewModel[]>;

  @AgendaStore.Mutation(AGENDA_SET_APPOINTMENT_BY_FIELD)
  storeAssignValueForAppointment: <T>(payload: { [key: string]: T }) => void
  @AgendaStore.Action(AGENDA_DELETE)
  storeRemoveAppointment: (payload: { originId: string, ticketId: string }) => Promise<any>;
  @AgendaStore.Action(AGENDA_MODIFY)
  storeQuickUpdateAppointment: (payload: IAppointmentQuickUpdate) => Promise<any>;

  @AgendaStore.Action(AGENDA_GET_APPOINTMENT_BY_ID)
  storeGetAppointmentById: (id?: number) => Promise<IAppointment>;
  @AgendaStore.Action(AGENDA_ASSIGN_APPOINTMENT)
  storeAssignAppointment: (appointment: IAppointment) => Promise<IAppointment>;

  @AgendaStore.Action(AGENDA_RECORD)
  storeRecordAppointment: (type?: string) => Promise<any>;

  get currentDate(): Moment {
    return moment();
  }
  get currentDateFormatted(): string {
    return this.currentDate.format("MMM YYYY")
  }

  get temporaryEvent(): IAppointmentListingViewModel {
    const appointment = <IAppointmentListingViewModel>{
      block: { name: this.blockInfo.name },
      fk_block: this.blockInfo.id,
      originId: (this.appointment.id || -1).toString(),
      title: this.appointment.name,
      description: this.appointment.description,
      start: moment.utc(this.appointment.start_date),
      end: moment.utc(this.appointment.end_date),
      _id: this.dtEventId
    }

    if (this.appointment.independent_contractors && this.appointment.independent_contractors.length) {
      const selectedIcs = _.filter(this.ics,
        ic => _.includes(this.appointment.independent_contractors, ic.id))
      appointment.ics = selectedIcs.map(x => {
        return { firstname: x.firstname, lastname: x.lastname, email: x.email, cellphone: x.cellphone, avatar: `${(x.firstname || '').substring(0, 1)}${(x.lastname || '').substring(0, 1)}` }
      })
    }
    if (this.appointment.id === undefined) {
      appointment['_id'] = "-1";
    }
    return appointment;
  }
  get events(): IAppointmentListingViewModel[] {
    return this.dtEvents.concat([this.temporaryEvent])
  }

  get canUpdate(): boolean {
    const { update_appointment, update_event } = this.$route.meta;
    return update_appointment || update_event || false
  }
  get coIsAppointment(): boolean {
    return this.appointment.type === AppointmentTypes.Appointment;
  }
  get modalTitle(): string {
    if (!this.coIsAppointment && this.appointment.id > 0) {
      return this.lblSetting.agendaModalTitleEventModification
    }

    return this.lblSetting.agendaModalTitle
  }
  renderColumnHeader(mon: Moment) {
    return '<i class="fc-day-header-cus fc-day-header-weekday">' + mon.format("dddd") + '</i></br><i class="title fc-day-header-cus fc-day-header-cus--bigger">' + mon.format('DD') + '</i>';
  }

  _clearTimeout: any
  handleUpdateEvent(event: IAppointmentListingViewModel) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this._agentView.fullCalendar('removeEvents', [event['_id'] || -1])
      this._agentView.fullCalendar('renderEvent', event)
    }, 500);
  }

  handleSave() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      const modal: any = this.$refs['modal'];
      if (modal.$refs.form.validate()) {
        this.dtValidateIsLoading = true;
        this._handleSave();
      }
    }, 300);
  }
  _handleSave() {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeRecordAppointment(this.appointment.appointment_state)
        .then((payload: {
          appointment: IAppointmentListingViewModel,
          isUpdate: boolean
        }) => {
          this._agentView.fullCalendar('removeEvents', [this.appointment.id])
          this._agentView.fullCalendar('renderEvent', payload.appointment, true);
          this.dtValidateIsLoading = false;
          this.dtAgendaDialogVisible = false;
          this.storeAssignAppointment(this.previousAppointment);
          this.previousAppointment = null
        })
        .catch(error => {
          this.dtValidateIsLoading = false;
          this.dtAgendaDialogVisible = false;
          this.storeAssignAppointment(this.previousAppointment);
          this.previousAppointment = null
          throw error;
        })
    }, 300);
  }

  handleBeforeClose(event) {
    if (this.previousAppointment) {
      this.storeAssignAppointment(this.previousAppointment);
      this.previousAppointment = null
    }
  }
  mounted() {
    setTimeout(() => {
      this.dtIsRender = true
    }, 1000);

    this.$watch('dtIsRender', this.renderCalendar)
    this.$watch('temporaryEvent', value => {
      const diff = value.end.diff(value.start, 'm');
      if (diff > 0 && this._agentView && !this.dtIsLoading && this.appointment.id === undefined) {

        this.handleUpdateEvent(value);
      }

      if(!this.udpateAppointmentField) this.rerenderEvents()
    })

    /** Get permission manually */
    const functionalities = localStorage.getItem("agenda");
    if (functionalities === null) {
      Axios.get('/functionality', { params: { module: 'agenda' } })
        .then(res => {
          const { data } = res.data.data
          const response: { [key: string]: boolean } = {}

          data.forEach((x: string) => {
            response[x] = true;
            this.$route.meta[x] = true
          });

          console.log(response);

          localStorage.setItem('agenda', JSON.stringify(response))
        })
    } else {
      this.handleParseFunctionalities(JSON.parse(functionalities))
    }

  }

  rerenderEvents() {
    this._agentView.fullCalendar('removeEvents')
    this._agentView.fullCalendar('refetchEvents')
  }

  handleParseFunctionalities(functionalities: { [key: string]: boolean }) {
    Object
      .keys(functionalities)
      .forEach((key: string) => this.$route.meta[key] = functionalities[key])
  }
  handleRenderEventElement(event, element) {
    try {
      const AgendaEventItem = require('../../../agenda/components/agenda-event-item/AgendaEventItem.vue').default;
      const self = this;
      return new AgendaEventItem({
        i18n: self.$i18n,
        data: () => ({
          event: event,
          canRemove: this.getCanRemove(event),
          canUpdate: this.getCanUpdate(event),
          allowResizable: true
        }),
        methods: {
          handleDelete: (event) => self.handleDelete(event),
          handleConvert: (event) => self.handleConvert(event),
          handleUpdate: (event) => self.handleUpdate(event)
        }
      }).$mount().$el;
    } catch (error) {
      console.log(error)
    }
  }

  handleDelete(event: AppointmentListingViewModel) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeRemoveAppointment({ originId: event.originId, ticketId: event.ticketId })
        .then(response => {
          setTimeout(() => {
            $('.menuable__content__active').remove();
          }, 200);
          this._agentView.fullCalendar('removeEvents', [event['_id']]);
        })
        .catch(error => console.log(error))
    }, 300);
  }
  handleConvert(event: AppointmentListingViewModel) {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeQuickUpdateAppointment({ id: event.originId, appointment_state: 'confirmed' })
        .then(response => {
          setTimeout(() => {
            $('.menuable__content__active').remove();
          }, 200);

          this._agentView.fullCalendar('removeEvents', [event['_id']]);
          this._agentView.fullCalendar('renderEvent', new AppointmentListingViewModel(response));
        })
        .catch(error => console.log(error))
    }, 300);
  }
  handleUpdate(event: any) {
    if (event._id === '-1') {
      if (this.previousAppointment !== null) {
        this.storeAssignAppointment(this.previousAppointment);
      }
    } else {
      this.previousAppointment = JSON.parse(JSON.stringify(this.appointment));

      const appointment: any = this.originalAppointments.find(x => x.id === Number(event.originId));

      this.storeAssignAppointment(appointment);
      this.dtAgendaDialogVisible = true
    }
  }


  async  handleFetchEvents(start, end, timezone, callback) {
    this.dtCalendarSearchParam.firstday = start.format("YYYY-MM-DD");
    this.dtCalendarSearchParam.lastday = end.format("YYYY-MM-DD");
    if (this.appointment.independent_contractors) {
      this.dtCalendarSearchParam.ic = this.appointment.independent_contractors as number[]
    } else {
      delete this.dtCalendarSearchParam.ic
    }
    this.dtIsLoading = true
    await this.storeGetAppointments(this.dtCalendarSearchParam)
      .then((response: any) => {
        this.dtIsLoading = false;
        this.dtEvents = response.events;
        this.originalAppointments = response.originalAppointments;
        callback(this.events);

      })
      .catch((error) => console.log(error))
  }

  handleGotoDate(type: "today" | "prev" | "next") {
    if (type === "today") {
      this._agentView.fullCalendar('gotoDate', moment())
    }
    else if (type === "next") {
      this._agentView.fullCalendar('gotoDate', this.currentDate.add(3, 'd'))
    } else {
      this._agentView.fullCalendar('gotoDate', this.currentDate.add(-3, 'd'))
    }

  }
  getCanRemove(event: { type: string, appointment_state: string, originId: string }) {
    //if (event.appointment_state === AppointmentState.Finished && event.type === AppointmentTypes.Appointment) return {}
    return {
      event: this.$route.meta.remove_event,
      appointment: this.$route.meta.remove_appointment && event.originId !== "-1"
    }
  }

  getCanUpdate(event: { type: string, appointment_state: string, originId: string }) {

    //if (event.originId !== "-1" && event.appointment_state === AppointmentState.Finished && event.type === AppointmentTypes.Appointment) return {}
    return {
      event: this.$route.meta.update_event,
      appointment: this.$route.meta.update_appointment
    }
  }

  handleDrop(event, delta, revertFunc, jsEvent, ui, view) {

    if (event._id === "-1") {
      this.storeAssignValueForAppointment({
        start_date: event.start.format(),
        end_date: event.end.format()
      })
    } else {
      /*if (event.appointment_state === AppointmentState.Finished || !this.canUpdate) {
        revertFunc();
        return;
      }*/
      this.storeQuickUpdateAppointment({
        id: event.originId,
        start_date: event.start.format(),
        end_date: event.end.format()
      })
        .catch(error => {
          revertFunc();
        })
    }
  }

  handleResize(event, delta, revertFunc, jsEvent, ui, view) {
    if (event._id === "-1") {
      this.storeAssignValueForAppointment({
        start_date: event.start.format(),
        end_date: event.end.format()
      })
    } else {

      /*if (event.appointment_state === AppointmentState.Finished || !this.canUpdate) {
        revertFunc();
        return;
      }*/
      this.storeQuickUpdateAppointment({
        id: event.originId,
        start_date: event.start.format(),
        end_date: event.end.format()
      })
        .catch(error => {
          console.log(error)
          revertFunc();
        })
    }
  }
  handleViewDestroy(view, element) {
    $('.calendar-menu-popover').remove(); /** Clear popover's DOM when change view or change page */
  }

  handleSelect(start: Moment, end: Moment, jsEvent, view) {
    console.log(this.appointment);

    this.storeAssignValueForAppointment({
      start_date: start.format(),
      end_date: end.format(),
    })
  }

  handleEventClick(calEvent, jsEvent, view) {
    console.log(calEvent);

  }

  renderCalendar() {
    console.log('render calendar render')
    this._agentView = ($(calendar) as any).fullCalendar({
      defaultView: 'agenda3daysview',
      slotLabelFormat: 'HH',
      firstDay: 1,
      locale: this.$i18n.locale,
      eventLimit: true,
      selectable: this.appointment.id === undefined,
      editable: true,
      lazyFetching: true,
      nowIndicator: true,
      eventOverlap: true,
      columnHeaderHtml: (moment) => this.renderColumnHeader(moment),
      events: (start, end, timezone, callback) => this.handleFetchEvents(start, end, timezone, callback),
      eventRender: (event, element) => this.handleRenderEventElement(event, element),
      eventDrop: (event, delta, revertFunc, jsEvent, ui, view) => this.handleDrop(event, delta, revertFunc, jsEvent, ui, view),
      eventResize: (event, delta, revertFunc, jsEvent, ui, view) => this.handleResize(event, delta, revertFunc, jsEvent, ui, view),
      select: (start, end, jsEvent, view) => this.handleSelect(start, end, jsEvent, view),
      height: () => {
        const verticalLine = document.getElementById('vertical-line');
        if (verticalLine) {
          return verticalLine.offsetHeight * 0.7;
        }
        return 600
      },
      viewDestroy: this.handleViewDestroy,
      scrollTime: moment(this.appointment.start_date).format("HH:mm:ss"),
      views: {
        agenda3daysview: {
          type: 'agenda',
          dayCount: 3
        }
      }
    })
  }
}

export default TicketCalendar;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-calendar/index.ts